import { OfferError } from 'pages/ElegantFallback/OfferError/OfferErrorController';

export const OfferModuleWrapperView = ({
  children,
  isOfferError,
  ...props
}) => {
  return <>{!isOfferError ? <div>{children}</div> : <OfferError />}</>;
};
